<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" placeholder="产品编码" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" placeholder="产品名称" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="客户编码"><el-input v-model="query.customerCode" placeholder="客户编码" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品分类">
        <el-select v-model="query.classifyId" size="small" clearable filterable style="width:150px">
          <el-option v-for="item in classifies" :key="item.classifyId" :label="item.classifyName" :value="item.classifyId" />
        </el-select>
      </el-form-item>
      <el-form-item label="仓库">
        <el-select v-model="query.wareHouseId" size="small" clearable filterable style="width:160px">
          <el-option v-for="item in warehouses" :key="item.wareHouseId" :label="item.wareHouseName" :value="item.wareHouseId" />
        </el-select>
      </el-form-item>
      <el-form-item label="有无库存">
        <el-select v-model="query.stockFlag" size="small" clearable style="width:110px">
          <el-option label="有库存" value="0" />
          <el-option label="无库存" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="canQueryQty" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="canQueryQty" type="primary" size="small" @click="exportFile">导出</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border show-summary :summary-method="summaryMethod" v-loading="loading" :header-cell-style="headStyle" @sort-change="sortChange">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="materialCode" label="产品编码" min-width="130" sortable="custom" show-overflow-tooltip>
        <template slot-scope="s">
          <a class="code-link" @click="openBom(s.row.materialCode)">{{ s.row.materialCode }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="产品名称" min-width="150" sortable="custom" show-overflow-tooltip />
      <el-table-column prop="customerCode" label="客户编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格型号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="classifyName" label="产品分类" min-width="120" show-overflow-tooltip />
      <el-table-column prop="unitName" label="库存单位" width="90" />
      <el-table-column prop="wareHouseName" label="仓库" min-width="140" show-overflow-tooltip />
      <el-table-column prop="quantity" label="库存数量" width="110" align="right" sortable="custom" />
      <el-table-column prop="usableQuantity" label="可用库存" width="110" align="right" sortable="custom" />
      <el-table-column v-if="inventoryQtyShowSupplier" prop="supplierName" label="供应商" min-width="120" show-overflow-tooltip />
      <el-table-column prop="safetyQty" label="安全库存" width="110" align="right" />
      <el-table-column label="操作" width="90" align="center">
        <template slot-scope="s">
          <el-button type="text" size="small" @click="openBom(s.row.materialCode)">BOM库存</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
    <quantity-search-bom v-if="bomVisible" ref="bomDialog" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'
import QuantitySearchBom from './QuantitySearchBom.vue'
export default {
  name: 'QuantitySearch',
  components: { QuantitySearchBom },
  mixins: [authMixin, inventoryQtyShowSupplierMixin],
  data() { return { query: { materialCode: '', materialName: '', customerCode: '', wareHouseId: '', classifyId: '', stockFlag: '', orderStr: '' }, classifies: [], warehouses: [], rows: [], pageIndex: 1, pageSize: 20, total: 0, quantityTotal: 0, usableQuantityTotal: 0, loading: false, bomVisible: false } },
  computed: {
    canQueryQty() {
      return this.isAuth('quantity:search:list') || this.isAuth('inventory:inventoryQuantity:list')
    }
  },
  created() { this.loadInventoryQtyShowSupplierPolicy(); this.loadClassifies(); this.loadWarehouses(); this.load() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { materialCode: '', materialName: '', customerCode: '', wareHouseId: '', classifyId: '', stockFlag: '', orderStr: '' }; this.search() },
    loadClassifies() {
      request.post('/base/materialClassify/list', {}).then(res => {
        const list = res.data || []
        const parents = {}
        list.forEach(item => { if (item.parentId) parents[item.parentId] = true })
        this.classifies = list.filter(item => !parents[item.classifyId])
      }).catch(() => { this.classifies = [] })
    },
    loadWarehouses() {
      request.get('/inventory/quantity/warehouses').then(res => { this.warehouses = res.data || [] }).catch(() => { this.warehouses = [] })
    },
    sortChange(column) {
      this.query.orderStr = column.order ? column.prop + ' ' + (column.order === 'descending' ? 'desc' : 'asc') : ''
      this.search()
    },
    summaryMethod({ columns }) {
      return columns.map((column, index) => {
        if (index === 1) return '总计'
        if (column.property === 'quantity') return this.quantityTotal
        if (column.property === 'usableQuantity') return this.usableQuantityTotal
        return ''
      })
    },
    exportFile() {
      const params = Object.assign({}, this.query, { pageIndex: undefined, pageSize: undefined })
      request.get('/inventory/quantity/export', { params, responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '库存查询.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(() => {})
    },
    load() {
      this.loading = true
      const params = Object.assign({}, this.query, { pageIndex: this.pageIndex, pageSize: this.pageSize })
      request.get('/inventory/quantity/search', { params }).then(res => {
        const body = res.data || {}
        this.rows = body.list || []
        this.total = body.totalCount || 0
        this.quantityTotal = body.quantityTotal || 0
        this.usableQuantityTotal = body.usableQuantityTotal || 0
      }).catch(() => { this.rows = []; this.total = 0; this.quantityTotal = 0; this.usableQuantityTotal = 0 }).finally(() => { this.loading = false })
    },
    openBom(code) {
      if (!code) return
      this.bomVisible = true
      this.$nextTick(() => this.$refs.bomDialog && this.$refs.bomDialog.init(code))
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.title-actions { float: right; margin-right: 28px; }
.line-tools { margin-bottom: 10px; }
.cards { margin-bottom: 12px; }
.card-num { font-size: 28px; font-weight: 600; margin-top: 8px; }
</style>
